import { render, staticRenderFns } from "./SettingControlCoordinates.vue?vue&type=template&id=fb5201b8&lang=pug&"
import script from "./SettingControlCoordinates.vue?vue&type=script&lang=js&"
export * from "./SettingControlCoordinates.vue?vue&type=script&lang=js&"
import style0 from "./SettingControlCoordinates.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports